import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyPagination,
	//MyButton,
	//MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Updatedlog 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaob  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	/*const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0);

	const [uDatamainObj,setDatamainObj]		= React.useState({})//-*/

	//--DLG_FORM--/
	//--END DLG_FORM--/

	const uDatalogsArr	= [
		{version:"2.3.3",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Pendapatan",teks_content:"Update Fitur, Revisi Definisi Omzet, yaitu Pendapatan per Tanggal Pembayaran Kasir beserta asuransi-nya."},
		],tgl_updated:"2026-09-25"},
		{version:"2.3.2",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Pendapatan",teks_content:"Update Fitur, Kolom Sisa Tidak Termasuk Asuransi, karena ditagihkan terpisah."},
		],tgl_updated:"2026-08-28"},
		{version:"2.3.1",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Pendapatan",teks_content:"Update Fitur, Kolom Pembayaran dan Payment di-Jumlahkan dan dijadikan SATU Kolom."},
		],tgl_updated:"2026-08-24"},
		{version:"2.3.0",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Pendapatan",teks_content:"Update Fitur, Menambahkan Filter Kasir yang menerima pembayaran."},
			{teks_menu:"Laporan >> Klinik >> Lap.Pasien Baru",teks_content:"Update Fitur, Menambahkan Data Kolom Jenis Kelamin pada Laporan."},
		],tgl_updated:"2026-08-20"},
		{version:"2.2.0",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Pendapatan",teks_content:"Update Fitur, Menambahkan Menu Lap.Pendapatan, untuk transaksi sesuai periode filter, tanpa pembayaran Piutang."},
			{teks_menu:"Klinik Sistem >> Kasir >> Rekap Nota >> Edit Nota",teks_content:"Update Fitur, Penambahan Form Edit Nota, untuk Perbaikan kesalahan Metode Pembayaran."},
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update Fitur, Memperbaiki BUG pada DISKON Transaksi lama."},
		],tgl_updated:"2026-08-08"},
		{version:"2.1.3",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update Fitur, Menambahkan Kolom sesuai REQUEST pada Format Export EXCEL (Re-arranged)."},
			{teks_menu:"App",teks_content:"Pindah Server VPS."},
		],tgl_updated:"2026-05-01"},
		{version:"2.1.2",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update Fitur, Menambahkan Kolom sesuai REQUEST pada Format Export EXCEL."},
		],tgl_updated:"2026-03-31"},
		{version:"2.1.1",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update BUG, Memunculkan kembali DISKON TRANSAKSI, karena Transaksi Lama masih menggunakan Diskon Transaksi."},
		],tgl_updated:"2026-03-27"},
		{version:"2.1.0",updated_arr:[
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Billing Periksa",teks_content:"Update Fitur, Perubahan Fitur Alur Diskon Diubah menjadi Diskon Item, dari semula Diskon Total."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Rekammedis",teks_content:"Update Fitur, Perubahan Fitur Alur Diskon Diubah menjadi Diskon Item, dari semula Diskon Total.<br/>Diskon Total di-HIDE jika NOL, sehingga yang lama masih bisa keluar."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir >> Bayar",teks_content:"Update Fitur, Perubahan Fitur Alur Diskon Diubah menjadi Diskon Item, dari semula Diskon Total.<br/>Perubahan Metode Payment menjadi multiple payment dalam Satu nota."},
			{teks_menu:"Klinik Sistem >> Kasir >> Bayar Cicilan Pasien >> Bayar",teks_content:"Update Fitur, Perubahan Metode Payment menjadi multiple payment dalam Satu nota."},
			{teks_menu:"Klinik Sistem >> Kasir >> Klaim Asuransi",teks_content:"Update Fitur, pada View Detil untuk menampilkan diskon Item."},
			{teks_menu:"Klinik Sistem >> Kasir >> Rekap Nota",teks_content:"Update Fitur, pada View Detil untuk menampilkan diskon Item, dan Diskon Total di-HIDE, agar transaksi lama tetap muncul.<br/>Menambahkan list multiple payment yang baru."},
			{teks_menu:"Laporan >> Operasional >> Lap.Fee Dokter",teks_content:"Update Fitur, Perubahan alur pemotongan fee Diskon dari sebelumnya Diskon Total menjadi Diskon per Item.<br/>Perubahan Interval Filter Tanggal Menjadi tgl 26 s.d. tgl 25."},
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update Fitur, Memunculkan Item Terapi dengan Diskon per Item.<br/>Memunculkan Multiple Payment sesuai Fitur yang baru."},
			{teks_menu:"Laporan >> Operasional",teks_content:"Update Fitur, Perubahan Interval Filter Tanggal Menjadi tgl 26 s.d. tgl 25."},
			{teks_menu:"Laporan >> Klinik",teks_content:"Update Fitur, Perubahan Interval Filter Tanggal Menjadi tgl 26 s.d. tgl 25."},
			{teks_menu:"Aplikasi >> Toast",teks_content:"Update Fitur, Manajemen Toast yang baru, dan lebih efektif."},
			{teks_menu:"Login",teks_content:"Update Fitur, Menambah fitur cek lokasi akses, untuk memudahkan tracing."},
			{teks_menu:"Master Data >> Data Sistem >> Data Pengguna",teks_content:"Update Fitur, Menampilkan daftar Log Akses user, untuk keperluan pemantauan akses sistem."},
			{teks_menu:"API >> Api Module",teks_content:"Update Fitur, Mulai Upgrade versi framework REST API untuk beberapa fitur."},
		],tgl_updated:"2026-03-10"},
		{version:"2.0.2",updated_arr:[
			{teks_menu:"Nama Aplikasi",teks_content:"Update Fitur, Mengubah Nama Aplikasi menjadi NARA E-system."},
		],tgl_updated:"2025-09-03"},
		{version:"2.0.1",updated_arr:[
			{teks_menu:"Logo dan Template Aplikasi",teks_content:"Update Fitur, Mengubah Logo dan Warna tampilan Aplikasi."},
			{teks_menu:"Dashboard",teks_content:"Update Fitur, Penambahan fitur Refresh untuk setiap CARD, agar Loading Lebih Cepat dan Efisien."},
			{teks_menu:"Laporan >> Operasional >> Lap.Rekap Kunjungan",teks_content:"Update Fitur, Penambahan Laporan Baru."},
			{teks_menu:"Laporan >> Operasional >> Lap.Asuransi",teks_content:"Update Fitur, Penambahan Laporan Baru."},
			{teks_menu:"Laporan >> Klinik >> Lap.Kinerja Dokter",teks_content:"Update Fitur, Penambahan Laporan Baru."},
			{teks_menu:"Laporan >> Operasional >> Lap.Pasien Baru",teks_content:"Update Fitur, Penambahan Laporan Baru."},
			{teks_menu:"Laporan >> Operasional >> Lap.Fee Dokter",teks_content:"Update Fitur, Perubahan Fitur seperti OMNI."},
			{teks_menu:"Laporan >> Operasional >> Lap.Laba/Rugi",teks_content:"Update Fitur, Mengaktifkan fitur Export Excel yang ternyata belum ada."},
			{teks_menu:"Master Data >> Setting >> Konfigurasi Data",teks_content:"Update Fitur, Membagi Menu Konfigurasi menjadi Konfigurasi Data dan Konfigurasi Klinik."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Daftar Reservasi",teks_content:"Update Fitur, Mengubah Filter Tampilan dan Toggle Display Ruangan."},
			{teks_menu:"Klinik Sistem >> Kunjungan Pasien >> Status Kunjungan",teks_content:"Update Fitur, Beberapa Perubahan Minor untuk optimalisasi Aplikasi."},
			{teks_menu:"Klinik Sistem >> Pasien >> Data Pasien >> Rekammedis",teks_content:"Update Fitur, Perubahan Fitur Update Kunjungan Rekammedis."},
			{teks_menu:"Klinik Sistem >> Kasir >> Pembayaran Kasir",teks_content:"Update Fitur, Kasir dapat menambahkan Item Terapi dan Memunculkan Fitur Tanggungan Asuransi.<br/>Pembayaran Kasir kini juga dapat dilakukan dengan perangkat MOBILE."},
			{teks_menu:"API >> Password User",teks_content:"Update Fitur, Memperbaiki Fitur Pembuatan Password User agar lebih terjamin keamanannya."},
		],tgl_updated:"2025-09-02"},
		{version:"1.x.x",updated_arr:[
			{teks_menu:"Aplikasi",teks_content:"Paket Sistem default."},
		],tgl_updated:"2024-09-03"},
	]
	const uJmlData	= uDatalogsArr.length;

	//---HANDEL--/
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentMain = () => {
		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);

		const vDataviewArr	= uDatalogsArr.slice(vMin,(vMax));

		return (
		<>
		{vDataviewArr.map((vItems,vKeys)=>{
			const vItemsArr	= vItems.updated_arr || [];

			return (
			<CCard className="mb-3 classbgcard" key={vKeys}>
			<CCardHeader className="d-flex justify-content-between">
				<div>Ver: <b>{vItems.version}</b></div>
				<div className="classfontsmaller"><small>{UFunc.HariAngka(vItems.tgl_updated)}</small></div>
			</CCardHeader>
			<CCardBody>
			<ul>
			{vItemsArr.map((vItemcontent,vKeycontent)=>{
				return (
				<li key={vKeycontent}>
					<div className="fw-bolder">{vItemcontent.teks_menu}</div>
					<small className="d-block fst-italic">{UFunc.renderHTML(vItemcontent.teks_content)}</small>
				</li>
				)//>
			})}
			</ul>
			</CCardBody>
			</CCard>
			)//>
		})}
		</>
		)//>
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = () => {}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
    	
    	apiLoaddata();

    	return () => {
    		setPageActive(1);
    	}
	},[])
	//---END EFFECT--/

	//console.log("(Updatedlog) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-4 p-0">
		<CContainer fluid className="classheadertop border-bottom"
			style={{height:64}}>
			<CHeaderToggler className="px-0" onClick={()=>uNavigate(-1)}>
			<CIcon icon="cilArrowCircleLeft" className="align-middle me-2" height={30}/>
			</CHeaderToggler>

			<CHeaderBrand className="me-auto">
				<small className="fw-bolder">
				Updated Logs<span className="d-none d-md-inline ms-1">{pjson.name}</span>
				</small>
			</CHeaderBrand>

			<CHeaderNav className="">
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-1 px-md-2 px-lg-5">
		<CContainer xxl className="px-0 mb-3">
			{contentMain()}

			{(uJmlData > uMaxData) && (
			<CCard>
			<CCardBody>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardBody>
			</CCard>
			)}
		</CContainer>
		</div>
		</div>
		</>
	)//>
}	

export default Updatedlog